import auth from './auth'
import game from './game'
import animation from './animation'

export default {
    auth,
    game,
    animation
}
